import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class PlayEndDown extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const isLastEop = !play
            .getFragmentsBetween(fragment, FootballState.EndOfPlay)
            .some(
                ({ associatedState, id }) =>
                    associatedState === FootballState.EndOfPlay &&
                    id !== fragment.id
            );

        return (
            fragment.associatedState === FootballState.NoPenaltyEndOfPlay ||
            isLastEop
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return [];
    }
}
